import LinkNameStep from "./LinkNameStep/LinkNameStep";
import PreviousRecipientsStep from "./PreviousRecipientsStep/PreviousRecipientsStep";
import RecipientsStep from "./RecipientsStep/RecipientsStep";
import RestrictionsStep from "./RestrictionsStep/RestrictionsStep";
import ReviewStep from "./ReviewStep/ReviewStep";
import ShareReportStep from "./ShareReportStep/ShareReportStep";

export default {
  LinkNameStep,
  PreviousRecipientsStep,
  RecipientsStep,
  RestrictionsStep,
  ReviewStep,
  ShareReportStep,
};
